import {
	logger,
} from '@config/logger';

/* Run this very early – e.g. a Snippet you execute
   just after opening DevTools, or a <script> in <head>.  */
export const diagJQueryOverrides = () => {
	let lastValue = window.$;
	if (window.$ !== lastValue) {
		logger.warn('⚠️  window.$ changed', {
			new: window.$,
			old: lastValue,
		});
		if (lastValue && !window.$) {
			debugger;
		}
		lastValue = window.$;
	}
};

